import appReducer from './appReducer';
import inventoryReducer from './inventoryReducer';
import volunteerReducer from './volunteerReducer';

import {combineReducers} from 'redux';


const rootReducer = combineReducers({
    app : appReducer,
    inventory: inventoryReducer,
    volunteer : volunteerReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js